module.exports = __webpack_public_path__ + "static/media/fanyuvo_restaurant_menu_english.37f97a83.pdf";